namespace Nobox {

    @Serenity.Decorators.registerFormatter()
    export class CampaignStatusFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            var status = ctx.value;
            if (status == 1) {
                return `<div class="status-link lkbadge lkbadge-secondary lkbadge-dim"><i class="icon fa fa-file-text pr-1"></i>DRAFT</div>`;
            } else if (status == 2) {
                return `<div class="status-link lkbadge lkbadge-warning lkbadge-dim"><i class="icon fa fa-clock pr-1"></i>PROCESS</div>`;
            } else if (status == 3) {
                return `<div class="status-link lkbadge lkbadge-success lkbadge-dim"><i class="icon fa fa-check pr-1"></i>DONE</div>`;
            } else {
                return `<div class="status-link lkbadge lkbadge-danger lkbadge-dim"><i class="icon fa fa-close pr-1"></i>CANCELED</div>`;
            }
        }
    }
}